module.exports = __webpack_public_path__ + "fonts/STKBureauSans-Medium.74a95332464d05527d165fc63f351864.ttf";